import { initAll } from "govuk-frontend";

initAll();
